import { LineDataType } from "../AnalyticComponents/AnalyticCharts"

export const formatLineChart = (data:LineDataType[]) => {
    let newData:any[] = []
    let dataKeys:{key:string, color:string}[] = []
    data.map(d => {
        let dataPoint = { name:d.name }
        d.data.map(da => {
            let foundKey = dataKeys.find(k => k.key == da.label)
            if(!foundKey){ dataKeys.push({ key:da.label, color:da.color }) }
            dataPoint = { ...dataPoint, [da.label]: da.amt }
        })
        newData.push(dataPoint)
    })
    return { lineData:newData, dataKeys }
}